var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74014 12C8.74014 14.1333 10.4865 15.8691 12.6426 15.8691C14.7889 15.8691 16.5353 14.1333 16.5353 12C16.5353 9.85697 14.7889 8.12121 12.6426 8.12121C10.4865 8.12121 8.74014 9.85697 8.74014 12ZM18.3792 6.04606C20.0865 7.36485 21.5401 9.29455 22.584 11.7091C22.6621 11.8933 22.6621 12.1067 22.584 12.2812C20.4962 17.1103 16.7792 20 12.6426 20H12.6328C8.50599 20 4.78892 17.1103 2.70111 12.2812C2.62307 12.1067 2.62307 11.8933 2.70111 11.7091C4.78892 6.88 8.50599 4 12.6328 4H12.6426C14.7109 4 16.6718 4.71758 18.3792 6.04606ZM12.6437 14.4124C13.9803 14.4124 15.073 13.3264 15.073 11.9979C15.073 10.6597 13.9803 9.57362 12.6437 9.57362C12.5267 9.57362 12.4096 9.58332 12.3023 9.60272C12.2633 10.6694 11.3852 11.5227 10.3023 11.5227H10.2535C10.2242 11.6779 10.2047 11.833 10.2047 11.9979C10.2047 13.3264 11.2974 14.4124 12.6437 14.4124Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowBold);
export default __webpack_public_path__ + "static/media/Show_bold.b5c3153c24281f3d14f7560a99ef7620.svg";
export { ForwardRef as ReactComponent };